import { useLastRouterMatchProp, useRouterParam } from "hooks/router"

export default function useSelectedView() {
  let selectedView = useLastRouterMatchProp("selectedView")
  const selectedContentSet = useRouterParam("contentSetId")
  if (selectedContentSet) {
    selectedView = selectedContentSet
  }
  return selectedView
}
